/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Whether usage is returned in byte-months or raw bytes for the specified `timeFrame`. `UNSPECIFIED` is supported only in responses. 
*/
export enum UsageUnit {
  USAGE_UNIT_BYTE_MONTHS = 'BYTE_MONTHS',
  USAGE_UNIT_BYTES = 'BYTES',
  USAGE_UNIT_UNSPECIFIED = 'UNSPECIFIED'
}
